"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var CornerComponent = function CornerComponent(props) {
  var children = props.children,
    center = props.center,
    centerProps = props.centerProps,
    top = props.top,
    topProps = props.topProps,
    topLeft = props.topLeft,
    topRight = props.topRight,
    bottom = props.bottom,
    bottomProps = props.bottomProps,
    bottomLeft = props.bottomLeft,
    bottomRight = props.bottomRight,
    topLeftProps = props.topLeftProps,
    topRightProps = props.topRightProps,
    bottomLeftProps = props.bottomLeftProps,
    bottomRightProps = props.bottomRightProps,
    w = props.w,
    h = props.h,
    allPadding = props.allPadding,
    radius = props.radius,
    _a = props.position,
    position = _a === void 0 ? 'absolute' : _a,
    _b = props.hoverShow,
    hoverShow = _b === void 0 ? [] : _b,
    _c = props.autoTagRadius,
    autoTagRadius = _c === void 0 ? true : _c,
    restProps = __rest(props, ["children", "center", "centerProps", "top", "topProps", "topLeft", "topRight", "bottom", "bottomProps", "bottomLeft", "bottomRight", "topLeftProps", "topRightProps", "bottomLeftProps", "bottomRightProps", "w", "h", "allPadding", "radius", "position", "hoverShow", "autoTagRadius"]);
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-corner', position, {
      'inset-0': position === 'absolute',
      'has-all-padding': allPadding,
      'auto-tag-radius': autoTagRadius
    }),
    supportAllEvents: true
  }, CornerComponent), {
    radius: radius,
    w: w,
    h: h
  }), topLeft && react_1["default"].createElement(odc_frame_1["default"], __assign({
    padding: allPadding
  }, topLeftProps, {
    className: (0, classnames_1["default"])('absolute top-0 left-0 odc-corner-tl', {
      'odc-hover-show': hoverShow.includes('topLeft')
    }, topLeftProps === null || topLeftProps === void 0 ? void 0 : topLeftProps.className)
  }), topLeft), topRight && react_1["default"].createElement(odc_frame_1["default"], __assign({
    padding: allPadding
  }, topRightProps, {
    className: (0, classnames_1["default"])('absolute top-0 right-0 odc-corner-tr', {
      'odc-hover-show': hoverShow.includes('topRight')
    }, topRightProps === null || topRightProps === void 0 ? void 0 : topRightProps.className)
  }), topRight), bottomLeft && react_1["default"].createElement(odc_frame_1["default"], __assign({
    padding: allPadding
  }, bottomLeftProps, {
    className: (0, classnames_1["default"])('absolute bottom-0 left-0 odc-corner-bl', {
      'odc-hover-show': hoverShow.includes('bottomLeft')
    }, bottomLeftProps === null || bottomLeftProps === void 0 ? void 0 : bottomLeftProps.className)
  }), bottomLeft), bottomRight && react_1["default"].createElement(odc_frame_1["default"], __assign({
    padding: allPadding
  }, bottomRightProps, {
    className: (0, classnames_1["default"])('absolute bottom-0 right-0 odc-corner-br', {
      'odc-hover-show': hoverShow.includes('bottomRight')
    }, bottomRightProps === null || bottomRightProps === void 0 ? void 0 : bottomRightProps.className)
  }), bottomRight), top && react_1["default"].createElement(odc_frame_1["default"], __assign({
    padding: allPadding,
    flex: true,
    justifyContent: 'center'
  }, topProps, {
    className: (0, classnames_1["default"])('absolute inset-x-0 top-0 odc-corner-t', {
      'odc-hover-show': hoverShow.includes('top')
    }, topProps === null || topProps === void 0 ? void 0 : topProps.className)
  }), top), bottom && react_1["default"].createElement(odc_frame_1["default"], __assign({
    padding: allPadding,
    flex: true,
    justifyContent: 'center'
  }, bottomProps, {
    className: (0, classnames_1["default"])('absolute inset-x-0 bottom-0 odc-corner-b', {
      'odc-hover-show': hoverShow.includes('bottom')
    }, bottomProps === null || bottomProps === void 0 ? void 0 : bottomProps.className)
  }), bottom), center && react_1["default"].createElement(odc_frame_1["default"], __assign({
    padding: allPadding
  }, centerProps, {
    className: (0, classnames_1["default"])('absolute odc-corner-center', {
      'odc-hover-show': hoverShow.includes('center')
    }, centerProps === null || centerProps === void 0 ? void 0 : centerProps.className)
  }), center), children);
};
(0, spaui_utils_1.setComponentMark)(CornerComponent, info_1["default"]);
exports["default"] = react_1["default"].memo(CornerComponent);